import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 12a4 4 0 1 0 -8 0a4 4 0 0 0 8 0","key":"svg-0"}],["path",{"d":"M12 12h-8","key":"svg-1"}],["path",{"d":"M7 15l-3 -3l3 -3","key":"svg-2"}]]

/**
 * IconSwipeLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3dpcGUtbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjAgMTJhNCA0IDAgMSAwIC04IDBhNCA0IDAgMCAwIDggMCIgLz4KICA8cGF0aCBkPSJNMTIgMTJoLTgiIC8+CiAgPHBhdGggZD0iTTcgMTVsLTMgLTNsMyAtMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/swipe-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSwipeLeft = createReactComponent('outline', 'swipe-left', 'SwipeLeft', __iconNode);

export default IconSwipeLeft;